<footer class="govbook-footer">
  <div class="govbook-footer__pre-footer">
    <div class="govbook-container footer-pre-footer-inner">

      <div class="footer-logo">
        <div class="footer-logo__content">
          <a href="https://www.rbwm.gov.uk/" target="_blank" rel="noopener noreferrer"
            aria-label="Royal Borough of Windsor and Maidenhead (opens in new window)">
            <img src="assets/rbwm_logo_footer.png" alt="Royal Borough of Windsor and Maidenhead" class="logo">
          </a>
        </div>
      </div>

      <nav aria-labelledby="block-rbwm-footer-menu" id="block-rbwm-footer"
        class="block block-menu navigation navigation--footer">
        <h2 class="visually-hidden" id="block-rbwm-footer-menu">Footer</h2>
        <ul class="menu menu--footer">
          <li class="menu-item">
            <a target="_blank" aria-label="Disclaimer (opens in new window)" rel="noopener noreferrer"
              class="footer-links" href="https://www.rbwm.gov.uk/terms-and-disclaimer">Disclaimer</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Privacy (opens in new window)" rel="noopener noreferrer" class="footer-links"
              href="https://www.rbwm.gov.uk/council-and-democracy/strategies-and-policies/data-protection/privacy-notices">Privacy</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Cookies (opens in new window)" rel="noopener noreferrer" class="footer-links"
              href="https://www.rbwm.gov.uk/council-and-democracy/strategies-and-policies/data-protection/cookies-and-data-storage">Cookies</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Contact us (opens in new window)" rel="noopener noreferrer"
              class="footer-links" href="https://www.rbwm.gov.uk/council-and-democracy/contact-us">Contact us</a>
          </li>
          <li class="menu-item">
            <a target="_blank" aria-label="Accessibility statement (opens in new window)" rel="noopener noreferrer"
                class="footer-links" [routerLink]="['/accessibility-statement']">Accessibility statement</a>
          </li>
        </ul>
      </nav>

      <nav aria-labelledby="block-rbwm-socialmedia-menu" id="block-rbwm-socialmedia"
        class="block block-menu navigation navigation--social-media">
        <h2 class="visually-hidden" id="block-rbwm-socialmedia-menu">Social Media</h2>
        <ul class="menu menu--social-media">
          <li class="menu-item">
            <a target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook (opens in new window)"
              href="https://www.facebook.com/people/Royal-Borough-of-Windsor-Maidenhead/100064687237131/" class="social-media-link-icon--facebook">
              <span></span>
            </a>
          </li>
          <li class="menu-item">
            <a target="_blank" rel="noopener noreferrer" aria-label="Follow us on Twitter (opens in new window)"
              href="https://x.com/rbwm" class="social-media-link-icon--twitter">
              <span></span>
            </a>
          </li>
          <li class="menu-item">
            <a target="_blank" rel="noopener noreferrer" aria-label="Visit us on YouTube (opens in new window)"
              href="https://www.youtube.com/user/WindsorMaidenhead" class="social-media-link-icon--youtube">
              <span></span>
            </a>
          </li>
        </ul>
      </nav>

    </div>
  </div>

  <div class="govbook-footer__footer">
    <div class="govbook-container">
      <div class="govbook-row">
        <div class="govbook-row__full">
          <div class="govbook-region govbook-region--footer region region-footer">
            <div class="govbook-container padding-horizontal">
              <div class="govbook-region__inner govbook-region__inner--footer">
                <div id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
                  class="block block-localgov-core block-localgov-powered-by-block">
                  <span>Powered by
                    <a target="_blank" aria-label="Bookinglab | GovBook (opens in new window)"
                      class="govbook-powered-link"
                      href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=rbwm">bookinglab
                      | GovBook</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>